import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.orgStructureSpace',
    'package:data.higherEd.research.projects',
    'resource:data.dimensions.fsFunctions',
    'resource:data.dimensions.fsFunctions.entities.function',
    'resource:data.dimensions.glAccounts',
    'resource:data.dimensions.glAccounts.entities.account',
    'resource:data.dimensions.glAccounts.entities.account.attributes.isInMtdc',
    'resource:data.dimensions.glAccounts.entities.account.attributes.mtdcCategory',
    'resource:data.dimensions.glExpenses',
    'resource:data.dimensions.glExpenses.entities.entry',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.account',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.amount',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.fsFunction',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.organization',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.project',
    'resource:data.enums.mtdcCategory',
    'resource:data.enums.mtdcCategory.entries.fringe',
    'resource:data.enums.mtdcCategory.entries.nonSalary',
    'resource:data.enums.mtdcCategory.entries.salary',
  ],
  description: 'TODO',
  name: 'Data - GL',
} as const satisfies core.quiver.Package
